import { ComponentRef, Injectable } from '@angular/core';

import { DomService } from './dom.service';
import { LoadingMultipleRequestComponent } from '../components/loading-multiple-request/loading-multiple-request.component';

@Injectable()
export class LoadingService {
  requests: string[] = [];
  constructor(private domService: DomService) {}

  loadingRef: ComponentRef<{}>;

  showLoading(request: string) {
    if (this.requests.length === 0) {
      setTimeout(() => {
        this.loadingRef = this.domService.appendComponentToBody(
          LoadingMultipleRequestComponent
        );
      });
    }
    this.requests.push(request);
  }

  hideLoading(request: string) {
    this.requests = this.requests.filter(item => item !== request);
    if (this.loadingRef && this.requests.length === 0) {
      this.domService.destroyComponent(this.loadingRef);
    }
  }
}
